import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "@theg1group/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import { TimeframeProvider } from "./lib/timeframe.tsx";
import "./index.css";

const queryClient = new QueryClient({
	defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<ToastProvider>
				<TimeframeProvider>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</TimeframeProvider>
			</ToastProvider>
		</QueryClientProvider>
	</StrictMode>,
);
